import React, { useEffect, useState, useCallback } from "react";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";
import { useDispatch, useSelector } from "react-redux";
import {
  listRewardVouchers,
  updateRewardVoucher,
} from "../../Redux/Actions/rewardsAction";
import { columnsRewards } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";

const ListRewards = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const [searchQuery, setSearchQuery] = useState("");

  const rewardVouchers = useSelector((state) => state.rewards?.vouchers || {});
  const loading = useSelector((state) => state.rewards?.loading);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const dispatch = useDispatch();

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        search: debouncedSearch,
      };
      dispatch(listRewardVouchers(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh reward history list");
        }
      });
    },
    [dispatch, debouncedSearch]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  useEffect(() => {
    if (rewardVouchers?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: rewardVouchers.total,
      }));
    }
  }, [rewardVouchers]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleStatusChange = async (record, action) => {
    let payload = { id: record._id };

    if (action === "primary") {
      payload.primary = true;
    } else if (action === "remove-primary") {
      payload.primary = false;
    } else {
      payload.status = action;
    }
    await dispatch(updateRewardVoucher(payload));
    fetchDetails(pagination.current, pagination.pageSize);

  };

  return (
    <>
      <TableComponentsCp
        h3heading="Reward Voucher List"
        pagination={pagination}
        onChange={handleTableChange}
        columns={columnsRewards(handleStatusChange, canEdit)}
        buttonhead2={canAdd ? "Add Reward Voucher" : null}
        navigateTo2={canAdd ? "/rewards_voucher/add" : null}
        dataSource={
          Array.isArray(rewardVouchers?.data) ? rewardVouchers.data : []
        }
        loading={loading}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        setState={setSearchQuery}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListRewards;
